import { buildClassesHook } from '../../../helpers/styles';
import { Theme } from '../../../theme';

export const useClasses = buildClassesHook((theme: Theme) => ({
    piggybackTable: {
        '& thead th': {
            padding: '0.75rem 0.5rem',
        },
        '& td': {
            padding: '0.5rem',
        },
    },
    selectedLoadRow: {
        backgroundColor: theme.colors.primaryLight,
        borderBottomColor: `${theme.colors.primary} !important`, //TODO: Fix table styling
    },
    disabledLoadRow: {
        backgroundColor: theme.colors.lightestGrey,
        color: theme.colors.mediumDarkGrey,
    },
    noDataContainer: {
        minHeight: 250,
    },
}));
